const PASSIVE_FALSE = { passive: false };

export function installViewportGuards({
    documentLike = globalThis.document,
    windowLike = globalThis.window,
} = {}) {
    const prevent = (event) => event.preventDefault();
    const preventMultiTouch = (event) => {
        if (event.touches?.length > 1) {
            event.preventDefault();
        }
    };
    const preventBrowserZoom = (event) => {
        if (
            (event.ctrlKey || event.metaKey)
            && ['+', '-', '=', '0'].includes(event.key)
        ) {
            event.preventDefault();
        }
    };
    const preventControlWheel = (event) => {
        if (event.ctrlKey) {
            event.preventDefault();
        }
    };

    for (const eventName of [
        'gesturestart',
        'gesturechange',
        'gestureend',
    ]) {
        documentLike.addEventListener(
            eventName,
            prevent,
            PASSIVE_FALSE
        );
    }

    documentLike.addEventListener(
        'touchmove',
        preventMultiTouch,
        PASSIVE_FALSE
    );
    documentLike.addEventListener('dblclick', prevent);
    windowLike.addEventListener('keydown', preventBrowserZoom);
    windowLike.addEventListener(
        'wheel',
        preventControlWheel,
        PASSIVE_FALSE
    );

    return () => {
        for (const eventName of [
            'gesturestart',
            'gesturechange',
            'gestureend',
        ]) {
            documentLike.removeEventListener(
                eventName,
                prevent,
                PASSIVE_FALSE
            );
        }

        documentLike.removeEventListener(
            'touchmove',
            preventMultiTouch,
            PASSIVE_FALSE
        );
        documentLike.removeEventListener('dblclick', prevent);
        windowLike.removeEventListener('keydown', preventBrowserZoom);
        windowLike.removeEventListener(
            'wheel',
            preventControlWheel,
            PASSIVE_FALSE
        );
    };
}
